/**
 * File upload operations
 * Handles all file upload-related operations (Cloudinary)
 */

// Cloudinary will be imported lazily when needed
let cloudinaryService: any = null;
const getCloudinaryService = async () => {
  if (!cloudinaryService) {
    const module = await import('@/shared/services/cloudinaryService');
    cloudinaryService = module.cloudinaryService;
  }
  return cloudinaryService;
};

/**
 * File service for handling file uploads
 */
export const fileService = {
  /**
   * Upload a file to Cloudinary
   * @param file - The file to upload
   * @param folder - Optional folder path for organization
   * @returns The secure URL of the uploaded file
   */
  async uploadFile(file: File, folder?: string): Promise<string> {
    const cloudinaryServiceInstance = await getCloudinaryService();
    const options = folder ? { folder } : {};
    const result = await cloudinaryServiceInstance.uploadFile(file, options);
    return result.secure_url;
  }
};
